import cloneDeep from "lodash-es/cloneDeep";
import { listTemplate } from "./List";
import { collectionConstructorFactory } from "../collection/collectionConstructorFactory";
import deepFreeze from 'deep-freeze-strict';
const rawUniversalTemplate = cloneDeep(listTemplate);
rawUniversalTemplate.templateId = 'universal';
rawUniversalTemplate.name = '通用数据源';
rawUniversalTemplate.desc = '用于适配列表和表单业务模型的接口集合';
export const universalTemplate = deepFreeze(rawUniversalTemplate);
export const UniversalCollection = collectionConstructorFactory(universalTemplate);
export const universalApis = universalTemplate.apiTemplates.map(item => item.name);
//# sourceMappingURL=Universal.js.map
